<template lang="pug">
    div
        table.table-auto.border-collapse.border.w-full.bg-white
            table-header(:list="PROMOTIONS_LIST_TABLE_HEADERS")
            tbody
                template(v-for="(item, index) in promotions")
                    tr(:key="item._id")
                        td.border.border-gray-300.w-10.font-light.text-xs.text-center
                            span {{ rowNumber(index) }}
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-2
                            span(:title="item.name") {{ shortName(item.name) }}
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-2
                            span {{ stationName(item.group) }}
                        td.text-sm.font-thin.border.border-gray-300.text-left.p-2.whitespace-pre-line
                            span {{ item.prize }}
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-2
                            a.text-blue-600.underline(:href="item.rules_url" target="_blank" rel="noopener") правила
                        td.text-sm.font-medium.border.border-gray-300.text-center.p-2(:class="item.active ? 'text-green-600' : 'text-red-500'")
                            span {{ item.active ? 'Активен' : 'Неактивен' }}
                        td.text-xs.font-thin.border.border-gray-300.text-center.p-2
                            span {{ formatUntil(item.active_until) }}
                        td.text-xs.font-thin.border.border-gray-300.text-center.p-2
                            .flex.items-center.justify-center.gap-1(v-if="creatorName(item)")
                                img.w-6.h-6.rounded-full.border.object-cover.flex-shrink-0(
                                    v-if="creatorPhoto(item)"
                                    :src="creatorPhoto(item)"
                                    crossorigin="use-credentials"
                                )
                                .w-6.h-6.rounded-full.border.bg-gray-200.flex-shrink-0(v-else)
                                span.text-xs.text-gray-600 {{ creatorName(item) }}
                            span(v-else) —
                            .text-gray-500.mt-1 {{ formatCreated(item.created_at) }}
                        td.text-sm.font-thin.border.border-gray-300.text-center.p-2
                            button.text-sm.underline.cursor-pointer(v-if="canChange(item)" type="button" @click="$emit('edit', item)") изменить
                        td.text-sm.font-thin.border.border-gray-300.text-center.text-gray-500.w-50
                            delete-item(v-if="canChange(item)" :item="item" :context="{ name_space: 'promotions', action: 'DeletePromotion' }")
        template(v-if="totalPages > 1")
            pagination(
                :totalPages="totalPages"
                :perPage="perPage"
                :currentPage="currentPage"
                @pagechanged="onPageChange"
            )
</template>

<script>
import moment from 'moment';
import 'moment/locale/ru';
import TableHeader from '@/components/common/tables/table-header';
import DeleteItem from '@/components/common/delete';
import Pagination from '@/components/common/pagination';
import { PROMOTIONS_LIST_TABLE_HEADERS } from '@/configs/views';
import { USER_GROUPS } from '@/configs/user-groups';
import { PromotionsNameSpace, PromotionsActionTypes, PromotionsGetterTypes, PromotionsMutationTypes } from '@/store/promotions/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';

moment.locale('ru');

export default {
    name: "PromotionsTable",
    components: {
        'table-header': TableHeader,
        'delete-item': DeleteItem,
        'pagination': Pagination,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 0,
        }
    },
    computed: {
        PROMOTIONS_LIST_TABLE_HEADERS() {
            return PROMOTIONS_LIST_TABLE_HEADERS
        },
        promotions() {
            return this.$store.getters[`${PromotionsNameSpace}/${PromotionsGetterTypes.GetPromotions}`]
        },
        perPage() {
            return this.$store.getters[`${PromotionsNameSpace}/${PromotionsGetterTypes.GetPerPage}`]
        },
        userRole() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetRole}`])
        },
        userGroup() {
            return Number(this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetGroup}`])
        },
        seesAllGroups() {
            return this.userRole === 1 || this.userRole === 2 || this.userRole === 6
        },
    },
    methods: {
        rowNumber(index) {
            return (this.currentPage - 1) * this.perPage + index + 1
        },
        shortName(name) {
            const text = String(name || '')
            if (text.length <= 50) {
                return text
            }
            return `${text.slice(0, 50).trimEnd()}…`
        },
        stationName(group) {
            if (Number(group) === 0) {
                return 'Общая'
            }
            const station = USER_GROUPS.find((item) => item.value === group)
            return station ? station.name : 'группа не указана'
        },
        canChange(item) {
            if (this.seesAllGroups) {
                return true
            }
            return Number(item.group) !== 0 && Number(item.group) === this.userGroup
        },
        formatCreated(value) {
            if (!value) {
                return ''
            }
            return moment(value).utcOffset(180).format('D MMMM YYYY')
        },
        creatorName(item) {
            const author = item.created_by || {}
            if (!author || typeof author !== 'object') {
                return ''
            }
            return [author.firstname, author.lastname].filter(Boolean).join(' ')
        },
        creatorPhoto(item) {
            const photo = item.created_by && item.created_by.photo
            if (!photo || typeof photo !== 'object') {
                return ''
            }
            const path = photo.sm_path || photo.path
            if (!path) {
                return ''
            }
            if (/^https?:\/\//.test(path)) {
                return path
            }
            return `${process.env.VUE_APP_BASE_URL}/${String(path).replace(/^\.\//, '')}`
        },
        formatUntil(value) {
            if (!value) {
                return 'не задано'
            }
            return moment(value).utcOffset(180).format('D MMMM YYYY HH:mm')
        },
        async onLoad({ per_page, page, filters }) {
            const params = { per_page, page: page - 1 }
            if (filters && filters.group !== null && filters.group !== undefined && filters.group !== '') {
                params.group = filters.group
            }
            if (filters && filters.search) {
                params.search = filters.search
            }
            if (filters && (filters.active === true || filters.active === false)) {
                params.active = filters.active
            }
            if (filters && filters.sort) {
                params.sort = filters.sort
            }
            const body = await this.$store.dispatch(`${PromotionsNameSpace}/${PromotionsActionTypes.GetPromotions}`, { params })
            if (!body || !body.data) {
                this.totalPages = 0
                return
            }
            const perPage = body.data.per_page || per_page
            this.totalPages = Math.ceil((body.data.total || 0) / perPage)
        },
        onPageChange(page) {
            this.currentPage = page
            this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
        },
        reload() {
            return this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
        },
    },
    mounted() {
        this.onLoad({ per_page: this.perPage, page: this.currentPage, filters: this.filters })
    },
    beforeDestroy() {
        this.$store.commit(`${PromotionsNameSpace}/${PromotionsMutationTypes.SetEmptyPromotions}`)
    },
    watch: {
        filters: {
            handler(val) {
                this.currentPage = 1
                this.onLoad({ per_page: this.perPage, page: 1, filters: val })
            },
            deep: true,
        },
    },
}
</script>
